var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"components-default-style"},[_c('div',[_c('img',{staticClass:"default-style-img",style:({width: _vm.width, height: _vm.height}),attrs:{"src":require("../common/images/nodata.png"),"alt":""}}),_c('p',{staticClass:"gray"},[_vm._v("暂无数据")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }